/**
 * @generated SignedSource<<de5e274fd9f2e0b3d4194b8611a30699>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type scmpYoutubeContent$data = {
  readonly entityId: string;
  readonly publishedDate: number | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "scmpYoutubeContent";
};
export type scmpYoutubeContent$key = {
  readonly " $data"?: scmpYoutubeContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"scmpYoutubeContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "scmpYoutubeContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "b3356b372014c0132f571f0c3181f6a0";

export default node;
